module.exports = __webpack_public_path__ + "img/thumb-002-03.01734800.png";